<template>
  <div class="dataset-export-box">
    <div class="common-card-tabs-box">
      <el-tabs v-model="activeTab" class="tab-primary" type="card" @tab-click="onTabClick">
        <el-tab-pane v-if="isTabPaneVisible('Model')" label="模型" name="Model">
          <DataSetTable
            v-if="isTableVisible('Model')"
            ref="dataSetTable"
            :projId="projId"
            schemeType="Model"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="isTabPaneVisible('ModelGroup')"
          label="模型组"
          name="ModelGroup"
        >
          <DataSetTable
            v-if="isTableVisible('ModelGroup')"
            ref="dataSetTable"
            :projId="projId"
            schemeType="ModelGroup"
          />
        </el-tab-pane>
        <el-tab-pane v-if="isTabPaneVisible('Rs')" label="遥感影像" name="Rs">
          <DataSetTable
            v-if="isTableVisible('Rs')"
            ref="dataSetTable"
            :projId="projId"
            schemeType="Rs"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="isTabPaneVisible('Wmts')"
          label="WMTS地图服务"
          name="Wmts"
        >
          <DataSetTable
            v-if="isTableVisible('Wmts')"
            ref="dataSetTable"
            :projId="projId"
            schemeType="Wmts"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="isTabPaneVisible('Osgb')"
          label="倾斜摄影"
          name="Osgb"
        >
          <DataSetTable
            v-if="isTableVisible('Osgb')"
            ref="dataSetTable"
            :projId="projId"
            schemeType="Osgb"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="isTabPaneVisible('Panorama')"
          label="360全景图"
          name="Panorama"
        >
          <DataSetTable
            v-if="isTableVisible('Panorama')"
            ref="dataSetTable"
            :projId="projId"
            schemeType="Panorama"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="isTabPaneVisible('PointCloud')"
          label="点云"
          name="PointCloud"
        >
          <DataSetTable
            v-if="isTableVisible('PointCloud')"
            ref="dataSetTable"
            :projId="projId"
            schemeType="PointCloud"
          />
        </el-tab-pane>
        <el-tab-pane v-if="isTabPaneVisible('Cad')" label="二维图纸" name="Cad">
          <DataSetTable
            v-if="isTableVisible('Cad')"
            ref="dataSetTable"
            :projId="projId"
            schemeType="Cad"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="isTabPaneVisible('Vector')"
          label="矢量数据"
          name="Vector"
        >
          <DataSetTable
            v-if="isTableVisible('Vector')"
            ref="dataSetTable"
            :projId="projId"
            schemeType="Vector"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import DataSetTable from "./DataSetTable.vue";

import { Store } from "@/utils/store";

const SchemeTypeMapArray = [
  {
    name: "模型",
    value: "Model",
    permissionCode: "Project.Single.DataSet.Bim",
  },
  {
    name: "模型组",
    value: "ModelGroup",
    permissionCode: "Project.Single.DataSet.Bim",
  },
  {
    name: "遥感影像",
    value: "Rs",
    permissionCode: "Project.Single.DataSet.Rs",
  },
  {
    name: "WMTS地图服务",
    value: "Wmts",
    permissionCode: "Project.Single.DataSet.Wmts",
  },
  {
    name: "倾斜摄影",
    value: "Osgb",
    permissionCode: "Project.Single.DataSet.Osgb",
  },
  {
    name: "360全景",
    value: "Panorama",
    permissionCode: "Project.Single.DataSet.Panorama",
  },
  {
    name: "点云",
    value: "PointCloud",
    permissionCode: "Project.Single.DataSet.PointCloud",
  },
  {
    name: "二维图纸",
    value: "Cad",
    permissionCode: "Project.Single.DataSet.CadTree",
  },
  {
    name: "矢量数据",
    value: "Vector",
    permissionCode: "Project.Single.DataSet.Vector",
  },
];
export default {
  data() {
    return {
      activeTab: "Model",
    };
  },
  props: {
    projId: String,
  },
  components: {
    DataSetTable,
  },
  methods: {
    onTabClick() {
      if (!this.projId) {
        this.$message.warning("请先选择项目");
        return;
      }

      this.$nextTick(() => {
        this.updateDataSetList();
      });
    },
    updateDataSetList() {
      let domRef = this.$refs.dataSetTable;
      domRef.updateDataSetList();
    },
    getExportDataSetInfo() {
      let domRef = this.$refs.dataSetTable;
      let dataSets = domRef.getSelectDataSets();
      let scheme = "";
      if (this.activeTab.includes("Model")) {
        scheme = "Bim";
      } else {
        scheme = this.activeTab;
      }
      let exportDataSetInfo = { scheme, dataSets: dataSets };
      return exportDataSetInfo;
    },
    isTableVisible(tabName) {
      return this.activeTab === tabName;
    },
    isTabPaneVisible(tabName) {
      let find = SchemeTypeMapArray.find((el) => el.value === tabName);
      return this.isChecked(find.permissionCode);
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData;
      let find = permissionData.find(
        (el) => el.permissionCode === permissionCode
      );
      return find.isCheck;
    },
  },
};
</script>

<style lang="less" scoped>
.dataset-export-box {
  height: 100%;

  .common-card-tabs-box {
    height: 100%;

    /deep/ .el-tabs {
      height: 100%;
      // margin-top: 16px;

      .el-tab-pane {
        height: 100%;
      }

      .el-tabs__content{
        margin-top: 16px;
      }
    }
  }
}
</style>